import { useShowLayoutFootAndClose, useHideLayoutFootAndClose } from "@/hooks/business/layoutDiy"; /** 动态显示layout foot-close */
import { $t } from '@/locales';


/**
 * 传入确认按钮文字 包括顶部关闭 底部2个按钮
 * */
export function setConfirmAll(confirm: string) {
  useShowLayoutFootAndClose({
    label: {
      confirmLabel: $t(confirm),
    },
    showKey: ["header-close", "foot-back", "foot-confirm"],
  });
}

export function setAll() {
  useShowLayoutFootAndClose({
    showKey: ["foot-confirm", "foot-back", "header-close"],
  });
}
export function setOnlyClose() {
  useShowLayoutFootAndClose({ showKey: ["header-close"] });

}

export function setOnlyFoot(confirm: string, backLabel: string) {
  useShowLayoutFootAndClose({
    label: {
      confirmLabel: $t(confirm),
      backLabel: $t(backLabel),
    }, showKey: ["foot-back", "foot-confirm"]
  });

}

export function removeAll() {
  useHideLayoutFootAndClose();
}
